import { useSiteContent } from '../../content/useSiteContent'

const WhatsAppIcon = ({ className = 'w-8 h-8 sm:w-9 sm:h-9' }) => (
  <svg viewBox="0 0 448 512" fill="currentColor" className={className} aria-hidden="true">
    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
  </svg>
)

function getWhatsAppHref(number, message = "Hi Ray Optics! I'd like help with choosing frames or lenses.") {
  const digits = String(number || '').replace(/\D/g, '')
  // Normalize 10-digit Indian numbers without country code to 91...
  const normalized = digits.length === 10 ? `91${digits}` : (digits || '919490424422')
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`
}

export default function WhatsAppWidget() {
  const { site } = useSiteContent()
  const rawNumber = site.settings?.whatsapp || site.vars?.phone_tel || site.vars?.phone || '919490424422'
  const href = getWhatsAppHref(rawNumber)

  return (
    <aside
      aria-label="WhatsApp customer support"
      className="fixed bottom-[calc(5rem+env(safe-area-inset-bottom,0px))] left-4 sm:bottom-6 sm:left-6 z-40 flex items-center group select-none"
    >
      {/* Floating CTA Button - Static, clean, no bounce, no ping */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Ray Optics on WhatsApp"
        aria-describedby="whatsapp-cta-tooltip"
        title="Chat with us on WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 sm:w-[60px] sm:h-[60px] rounded-full bg-[#25D366] text-white shadow-xl shadow-black/25 hover:bg-[#20ba59] active:scale-95 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-[#25D366]/40"
      >
        <WhatsAppIcon className="w-8 h-8 sm:w-9 sm:h-9" />
      </a>

      {/* Tooltip on desktop (displayed to the right of the button) */}
      <div
        role="tooltip"
        id="whatsapp-cta-tooltip"
        className="hidden sm:flex items-center absolute left-full ml-3 top-1/2 -translate-y-1/2 px-3 py-1.5 rounded-xl bg-gray-900/90 backdrop-blur-sm text-white text-xs font-medium shadow-lg pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap"
      >
        <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900/90" />
        <span>Chat with us on WhatsApp</span>
      </div>
    </aside>
  )
}
